import { render, staticRenderFns } from "./BlobFrame.vue?vue&type=template&id=28649775&scoped=true"
import script from "./BlobFrame.vue?vue&type=script&lang=js"
export * from "./BlobFrame.vue?vue&type=script&lang=js"
import style0 from "./BlobFrame.vue?vue&type=style&index=0&id=28649775&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28649775",
  null
  
)

export default component.exports